module.exports = __webpack_public_path__ + "img/error-problem.8520bf64.svg";